import React, { useRef } from "react";
import { isMobileOnly } from "react-device-detect";
import styled from "styled-components";
import { UserEntity } from "@lifeat/shared/data-models/user/UserEntity";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import useOnUserDataLoaded from "@hooks/useOnUserDataLoaded";
import PlannerMobileInfoPage from "@pages/PlannerMobileInfoPage";
import Styles from "@themes/Styles";
import { BoardViewFilterService } from "../../BoardViewFilterService";
import { TaskListContext } from "../../TaskListContext";
import useTaskData from "../../useTaskData";
import { dynamicSidebarContent$, filteringSidebarOpen$, mainContent$ } from "../PlannerGlobals";
import CalendarWeekView from "./CalendarWeekView";
import PlannerDynamicSidebar from "./PlannerDynamicSidebar";
import { PlannerFilteringSidebar } from "./PlannerFilteringSidebar";
import PlannerTaskBoard, { PlannerBoardRef } from "./PlannerTaskBoard";
import PlannerTopNavigation from "./PlannerTopNavigation";
import ProjectsListView from "./views/ProjectsListView";

const PlannerContainer = styled.div`
    z-index: ${Styles.zIndexTopNavigation};
    display: flex;
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
`;

// TODO [LAS-1328]: fix height - https://github.com/LifeAtInc/LifeAtSpaces/pull/896#discussion_r1320075584
const TopNavAndBoardContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: ${(props) => props.theme.backgroundPrimary};
    width: 100%;
`;

const MainContentContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow: auto;
`;

function Planner() {
    const { user }: UserContextType = useUserContext();

    const taskData = useTaskData({
        uid: user?.uid,
        filterService: BoardViewFilterService(user?.uid),
    });
    const boardRef = useRef<PlannerBoardRef | null>(null);

    useOnUserDataLoaded((loadedData: UserEntity) => {
        if (loadedData?.lastViewedContent?.plannerSidebarContent) {
            dynamicSidebarContent$.value = loadedData.lastViewedContent.plannerSidebarContent;
        }
    });

    const planner = (
        <PlannerContainer>
            {filteringSidebarOpen$.value && <PlannerFilteringSidebar />}

            <TopNavAndBoardContainer>
                <PlannerTopNavigation boardRef={boardRef} />

                <MainContentContainer>
                    <PlannerTaskBoard
                        ref={boardRef}
                        taskList$={taskData.taskItems$}
                        isVisible={mainContent$.value === "task-board"}
                    />

                    <CalendarWeekView isVisible={mainContent$.value === "calendar"} />

                    <ProjectsListView isVisible={mainContent$.value === "projects"} />

                    <PlannerDynamicSidebar />
                </MainContentContainer>
            </TopNavAndBoardContainer>
        </PlannerContainer>
    );

    return (
        <TaskListContext.Provider value={taskData}>
            {isMobileOnly ? <PlannerMobileInfoPage /> : planner}
        </TaskListContext.Provider>
    );
}

export default Planner;
